export default "__VITE_ASSET__DUi$RJg8__"